import { useState } from "react"
import profileImage from '../../../assets/images/core/Profile.png'

export const CareerState = () => { 
      const [loader, setLoader] = useState(false)
      const [priority, setPriority] = useState(false)
      const [savePriority, setSavePriority] = useState(false)
      const [ehWay, setEhWay] = useState(false)
      const [profile, setProfile] = useState(false)
      const [gntResume, setGntResume] = useState(false)
      const [error, setError] = useState(true)
      const [createRank, setCreateRank] = useState([
                  { id: 1, label: "Health Benefits" },
                  { id: 2, label: "A positive and supportive work environment" },
                  { id: 3, label: "A job that brings long-term satisfaction" },
                  { id: 4, label: "Chances to learn new things and grow" },
                  { id: 5, label: "Work that feels meaningful and aligned" },
                  { id: 6, label: "Competitive Salary Pay" },
                  { id: 7, label: "Willingness to try new challenges (like fieldwork)" },
                  { id: 8, label: "Option to work from home" },
                  { id: 9, label: "Opportunity to have mentors" },
                  { id: 10, label: "Opportunity to be a mentor" },    
      ]);

      const [rankRead, setRankRead] = useState([])
      const [resultsLoader, setResultLoader] = useState(false)
      const [btnLoader,setBtnLoader] = useState(false)
      const [readProvince, setReadProvince] =useState([])
      const [readCity, setReadCity,] = useState([])
      const [readBrgy, setReadBrgy] = useState([])
      const [addressLoader, setAddressLoader] = useState(false)
      const [infoLoader, setInfoLoader] = useState(true)
      const [profileLoader, setProfileLoader] = useState(false)
      const [saveInfo, setSaveInfo] = useState([])
      const [infoModalSave, setInfoModalSave] = useState(false)
      const [saveOtherInfo, setSaveOtherInfo] = useState([])
      const [readPinfo, setReadPinfo] = useState([])
      const [educRead, setEducRead] = useState([])
      const [fieldOfStudy, setFieldOfStudy] = useState([])
      const [degree, setDegree] = useState([])
      const [strand, setStrand] = useState([])
      const [msg, setMsg] = useState(false)
      const [readAdrs, setReadAdrs] = useState ([])
      const [welcomeModal,setWelcomeModal] = useState(false)
      // const [educModal, setEducModal] = useState(false)

      const [pForm, setPForm] = useState ({ type: "create",
            submit: {modal: false, type: '', confirmed: false},
            inputs:{
                  profile: {value: null, object: profileImage, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
                  last_name: {value: '', stat: false, msg: '', toggled: false},
                  first_name: {value: '', stat: false, msg: '', toggled: false},
                  middle_name: {value: '', stat: false, msg: '', toggled: false},
                  suffix: {value: '', stat: false, msg: '', toggled: false},
                  province: {value: '', stat: false, msg: '', toggled: false},
                  city: {value: '', stat: false, msg: '', toggled: false},
                  brgy: {value: '', stat: false, msg: '', toggled: false},
                  zip: {value: '', stat: false, msg: '', toggled: false},
                  street: {value: '', stat: false, msg: '', toggled: false},
                  civil: {value: '', stat: false, msg: '', toggled: false},
                  gender: {value: '', stat: false, msg: '', toggled: false},
                  birthday: {value: '', stat: false, msg: '', toggled: false},
                  contact_info: {value: '', stat: false, msg: '', toggled: false},
      }})

       const [educForm, setEducForm] = useState ({ type: "create",
            submit: {modal: false, type: '', confirmed: false, checked: false},
            inputs:{           
                  schoolName: {value: '', stat: false, msg: '', toggled: false},
                  address: {value: '', stat: false, msg: '', toggled: false},
                  ref: {value: 0, stat: false, msg: '', toggled: false},
                  user_id: {value: '', stat: false, msg: '', toggled: false},
                  year_start: {value: '', stat: false, msg: '', toggled: false},
                  year_graduated: {value: '', stat: false, msg: '', toggled: false},
                  educational_attainment: {value: 1, stat: false, msg: '', toggled: false},
                  secondary_type: {value: '', stat: false, msg: '', toggled: false},
                  strand: {value: '', stat: false, msg: '', toggled: false},
                  course: {value: '', stat: false, msg: '', toggled: false},
                  degree: {value: '', stat: false, msg: '', toggled: false},
                  fields: {value: '', stat: false, msg: '', toggled: false},
      }})

      const [pInfo, setPInfo] = useState([  {label: 'Last name', name: 'last_name' , value:'',  stat: false, msg: "" },
         {label: 'First name', name: 'first_name'  , value:'', stat: false, msg: ""},
         {label: 'Middle name', name: 'middle_name', value:'', stat: false, msg: ""},
         { label: 'Suffix', 
            name: 'suffix', 
      }])

      const [adInfo, setAdInfo] = useState([
            {label: 'Province', name:'province', type:'select', api: 'province',value : '',  stat: false, msg: ""},     
            {label: 'City Municipality',name:'city', api: 'city', type:'select' ,   }, 
            {label: 'Barangay',name:'brgy',type:'select', api:'brgy' },
            {label: 'Zip Code' ,name:'zip', stat: false, msg: ""},  
            {label: 'Street/Building',name:'street', stat: false, msg: ""},
            {label: 'Civil Status',name: 'civil', type: 'select',  options: ['Single', 'Married', 'Divorced', 'Widowed'] , stat: false,  msg: "" },               
            {label: 'Gender' ,   name:'gender' ,   type: 'select',  options: ['Male', 'Female'] ,  stat: false, msg: ""},
            { label: 'Birthday',   name: 'birthday',   type: 'date'}                        
      ]);

   return {
      loader: {data: loader, set: setLoader},
      priority: {data: priority, set: setPriority},
      savePriority: {data: savePriority, set: setSavePriority},
      ehWay:{data: ehWay, set: setEhWay},
      profile:{data: profile, set: setProfile},
      gntResume:{data: gntResume, set: setGntResume },
      createRank:{data: createRank, set: setCreateRank},
      rankRead: {data: rankRead, set: setRankRead},
      resultsLoader: {data:resultsLoader, set: setResultLoader},
      btnLoader:{data: btnLoader, set: setBtnLoader},
      pForm:{data: pForm, set: setPForm},
      error: {data: error, set: setError},
      pInfo: {data: pInfo, set: setPInfo},
      adInfo: {data: adInfo, set: setAdInfo},
      readProvince: {data: readProvince, set: setReadProvince },
      readCity:{data: readCity, set: setReadCity},
      readBrgy: {data: readBrgy, set: setReadBrgy},
      addressLoader: {data: addressLoader, set: setAddressLoader},
      saveInfo: {data:saveInfo, set: setSaveInfo},
      infoModalSave: {data: infoModalSave, set: setInfoModalSave},
      saveOtherInfo: {data:saveOtherInfo, set: setSaveOtherInfo},
      readPinfo: {data: readPinfo, set: setReadPinfo},
      infoLoader: {data: infoLoader, set: setInfoLoader},
      profileLoader: {data: profileLoader, set: setProfileLoader},
      educForm: {data: educForm, set: setEducForm},
      educRead: {data: educRead, set: setEducRead},
      fieldOfStudy: {data: fieldOfStudy, set: setFieldOfStudy},
      degree: {data: degree, set: setDegree},
      strand: {data: strand, set: setStrand },
      msg:{data: msg, set: setMsg},
      readAdrs: {data: readAdrs, set: setReadAdrs},
      welcomeModal: {data: welcomeModal, set: setWelcomeModal}
      // educModal: {data: educModal, set: setEducModal}
   }
}
